// Core
import {
  ActionCreatorWithoutPayload,
  ActionCreatorWithPayload,
  createAction,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import { all, call, takeLatest } from 'redux-saga/effects';
// Instruments
import { loginSaga, logoutSaga } from '../workers';

export interface AuthState {
  storedUser: StoredUser | undefined;
  hasPermission: boolean | undefined;
}

export type AuthData = {
  token?: string;
};

export type StoredUser = {
  token?: string;
  userId?: string;
};

const authInitialState: AuthState = {
  storedUser: undefined,
  hasPermission: undefined,
};

const auth = createSlice({
  name: 'auth',
  initialState: authInitialState,
  reducers: {
    authenticate: (state, action: PayloadAction<StoredUser>): void => {
      state.storedUser = action.payload;
    },
    logout: (state): void => {
      state.hasPermission = undefined;
      state.storedUser = undefined;
    },
    setPermission: (state, action: PayloadAction<boolean>): void => {
      state.hasPermission = action.payload;
    },
  },
});

export const { authenticate, logout, setPermission } = auth.actions;

export default auth.reducer;

export const loginAsync: ActionCreatorWithPayload<AuthData> = createAction('auth/loginAsync');

export const logoutAsync: ActionCreatorWithoutPayload = createAction('auth/logoutAsync');

function* watchLogin(): SagaIterator {
  yield takeLatest(loginAsync, loginSaga);
}

function* watchLogout(): SagaIterator {
  yield takeLatest(logoutAsync, logoutSaga);
}

export function* watchAuthSagas(): SagaIterator {
  yield all([call(watchLogin), call(watchLogout)]);
}
